import './subscriptionFooterBlock.scss';
import { addGtmTrackingToEpiserverForms } from '@/components/EpiserverForms';

const subscriptionFooterBlockDivs = document.getElementsByClassName(
    'container--subscription-footer'
);

if (subscriptionFooterBlockDivs) {
    Array.from(subscriptionFooterBlockDivs).forEach((element) => {
        addGtmTrackingToEpiserverForms(element, 'SubscriptionFooterBlock');
    });
}
